import { useState, useEffect } from "react";

export const useDetectIOS = () => {
	const [isIOS, setIsIOS] = useState(false);

	useEffect(() => {
		function detectIOS() {
			if (typeof window !== "undefined" && typeof navigator !== "undefined") {
				if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
					return setIsIOS(true);
				}
			}
			return setIsIOS(false);
		}

		detectIOS();
	}, []);

	return { isIOS };
};
